module.exports = "pegasus/assets/hexagon-facebook.png";